<template>
	<div class = 'news' ref="news">
		<h2 class = 'mt-3'>News</h2>
		<div class = "card card-info bg-light my-3" v-if="jobAdd">
			<div class = "card-body">
				<h5><span style="font-weight: bold">Job opportunity: </span>we are looking for a bioinformatician (100%) to reinforce our team. <a href="https://career5.successfactors.eu/career?career%5fns=job%5flisting&company=universitdP&navBarLevel=JOB%5fSEARCH&rcm%5fsite%5flocale=fr%5fFR&career_job_req_id=16596&selected_lang=fr_FR&jobAlertController_jobAlertId=&jobAlertController_jobAlertName=&_s.crb=%2fUSj2ZXEGaOCb7zRKF%2bZ9zUOOoqCKzGF51tmkXqO8ds%3d" target="_blank" > More information and application <v-icon name="external-link-alt"></v-icon></a></h5>
			</div>
		</div>
		<div class = 'card-deck'>
			<div class = 'card' v-if="greetings">
				<img src="../../assets/bicc_xmas_2022.png" class="card-img-top" alt="Greetings">
			</div>
			<div class = 'card'>
				<a href = 'https://actu.epfl.ch/news/la-bio-informatique-est-un-domaine-en-constante-ev/'><img src="../../assets/bicc_chris.png" class="card-img-top" alt="Christian Iseli"></a>
			</div>
			<div class = 'card'>
				<a href = 'https://news.unil.ch/display/1575365652416'><img src="../../assets/bicc_nguex.png" class="card-img-top" alt="Nicolas Guex"></a>
			</div>
			<div class = 'card' v-if="!greetings">
				<a href = 'https://news.unil.ch/display/1570782710747' target = '_blank'><img src="../../assets/bicc_unil.png" class="card-img-top" alt="BICC"></a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'news',
	data () {
		return {
		}
	},
	computed: {
		jobAdd () {
			return new Date() <= new Date('2020-11-16')
		},
		greetings () {
			return new Date() <= new Date('2023-01-31')
		}
	},
	methods: {
	}
}
</script>

<style>
img.directions {
	cursor: pointer;;
}
</style>